export const GridConfig = ({ parser }) => ({
  id: 'VATs',
  mode: {
    isModalNew: true,
    isModalEditing: true
  },
  store: {
    get: {
      url: 'VATs/GetAllDynamic',
      selected: 'id,country,vatValue',
      parser
    },
    create: {
      url: 'VATs/Create'
    },
    patch: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'VATs/Patch/${data.id}'
    },
    delete: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'VATs/Delete/${data.id}',
      modal: {
        msgDataKey: 'country'
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("country")}',
      field: 'country',
      editor: {
        type: 'string',
        required: true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("vat-value")}',
      field: 'vatValue',
      editor: {
        type: 'number',
        required: true
      }
    }
  ],
  rowControls: {
    right: {
      controls: ['edit']
    }
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      }
    }
  },
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'country',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("search")}',
          styles: {
            minWidth: '25rem'
          }
        }
      }
    ]
  }
})
